import {
  AMCustomPolygonRankChartRequest,
  AMCustomPolygonRankListRequest,
  AMCustomPolygonRankPositionOverTimeRequest,
  AMCustomPolygonRankPositionRequest,
  CustomFootfall,
  CustomFootfallDatasetData,
  CustomFootfallRequest,
  CustomTradeAreaResponse,
} from 'src/common-services/types/custom-footfall-types'
import { BaseClient } from 'src/common-services/clients/base-client'
import { MultiPolygon } from '@turf/helpers'
import {
  AMDateValue,
  AMLocationRankByBrandListResponse,
  AMMobilityLocationRankChart,
  AMMobilityLocationRankPosition,
} from 'src/common-services/types/alphamap'

type MultipleCustomFootfall = Record<CustomFootfallDatasetData['dataset'], CustomFootfall<CustomFootfallDatasetData>>

export class CustomFootfallClient extends BaseClient {
  createMultipleCustomFootfall(request: CustomFootfallRequest): Promise<MultipleCustomFootfall> {
    return this.call<MultipleCustomFootfall>('/custom-footfall/reports/multiple', 'POST', {
      data: request,
    })
  }
  createCustomFootfall<TDataset extends CustomFootfallDatasetData>(
    request: CustomFootfallRequest
  ): Promise<CustomFootfall<TDataset>> {
    return this.call<CustomFootfall<TDataset>>('/custom-footfall/reports', 'POST', {
      data: request,
    })
  }

  getCustomFootfall<TDataset extends CustomFootfallDatasetData>(reportId: string): Promise<CustomFootfall<TDataset>> {
    return this.call<CustomFootfall<TDataset>>(`/custom-footfall/reports/${reportId}`, 'GET')
  }

  getUserCustomFootfallByPlaceIdAndDataset<TDataset extends CustomFootfallDatasetData>(
    id: string,
    dataset: TDataset['dataset']
  ): Promise<CustomFootfall<TDataset>> {
    return this.call<CustomFootfall<TDataset>>(`/custom-footfall/reports/place/${id}/dataset/${dataset}`, 'GET')
  }

  getCustomTradeAreaByPlaceId(placeId: string): Promise<CustomTradeAreaResponse> {
    return this.call<CustomTradeAreaResponse>(`/custom-footfall/trade-area/${placeId}`, 'GET')
  }

  getLatestPolygonByPlaceId(placeId: string): Promise<{ polygon: MultiPolygon | undefined }> {
    return this.call<{ polygon: MultiPolygon | undefined }>(`/custom-footfall/latest-polygon/${placeId}`, 'GET')
  }

  getCustomPolygonRankingPositionByPlaceId(
    request: AMCustomPolygonRankPositionRequest
  ): Promise<AMMobilityLocationRankPosition> {
    return this.call('/custom-footfall/category-rank/position', 'POST', {
      data: request,
    })
  }

  getCustomPolygonRankingChartByPlaceId(
    request: AMCustomPolygonRankChartRequest
  ): Promise<AMMobilityLocationRankChart[]> {
    return this.call('/custom-footfall/category-rank/chart', 'POST', {
      data: request,
    })
  }

  getCustomPolygonRankList(request: AMCustomPolygonRankListRequest): Promise<AMLocationRankByBrandListResponse> {
    return this.call('/custom-footfall/category-rank/list', 'POST', {
      data: request,
    })
  }

  getCustomPolygonRankPositionOverTime(request: AMCustomPolygonRankPositionOverTimeRequest): Promise<AMDateValue[]> {
    return this.call(`/custom-footfall/category-rank/position-over-time`, 'POST', {
      data: request,
    })
  }
}
